import React, { useEffect, useState, useCallback } from 'react';
import moment from 'moment';
import { useDispatch } from 'react-redux';
import { useTranslation } from 'react-i18next';

import { showSuccessSnackbar } from 'modules/snackbar';
import {
  appFiltering,
  appFilteringAdd,
  appFilteringDel,
} from 'lib/api/datacenter';

import NewInput from 'components/atoms/NewInput';
import NewButton from 'components/molecules/NewButton';
import NewTableContainer from 'components/molecules/NewTable';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import Modal from 'components/organisms/NewModal';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import FilterCollection from 'components/organisms/FilterCollection';

const AppFiltering = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const initParams = {
    sDate: moment().add(-1, 'month').add(-1, 'day').format('YYYYMMDD'),
    eDate: moment().add(-1, 'day').format('YYYYMMDD'),
    pltfomTpCode: 'all',
    osTpCode: 'all',
    sort: 'desc',
    order: 'APP_NO',
  };
  const initModal = {
    open: false,
    type: null,
    params: {
      osTpCode: '01',
      pkgNm: '',
      appDesc: '',
    },
    modalTitle: '', // 모달 타이틀
    confirmBtnTitle: '', // 모달 확인 버튼 영역 텍스트
  };

  const initError = {
    osTpCode: {
      state: false,
      helperText: '',
    },
    pkgNm: {
      state: false,
      helperText: '',
    },
    appDesc: {
      state: false,
      helperText: '',
    },
  };

  const [initialization, setInitialization] = useState(false);
  const [params, setParams] = useState(initParams);
  const [modal, setModal] = useState(initModal);
  const [error, setError] = useState(initError);
  const [checkData, setcCheckData] = useState('');
  const [loading, setLoading] = useState(false);
  const [reGetData, setReGetData] = useState(false);

  /**
   * 패치데이터 핸들러 초기화
   */
  useEffect(() => {
    if (reGetData === true) {
      setReGetData(false);
    }
  }, [reGetData]);

  /**
   * modal Close시 Error 상태 초기화
   */
  useEffect(() => {
    if (modal.open === false) {
      setError(initError);
    }
    // eslint-disable-next-line
  }, [modal]);

  /**
   * 필터 초기화 후 값을 바꿈
   */
  useEffect(() => {
    if (initialization === true) {
      setInitialization(false);
    } // eslint-disable-next-line
  }, [initialization]);

  /**
   * 페이지 파라미터를 관리하는 params을 수정하는 함수
   * @param newParams
   */
  const getParam = (newParams) => {
    if (JSON.stringify(params) !== JSON.stringify(newParams)) {
      setParams(newParams);
    }
  };

  /**
   * 필터 초기화
   */
  const handleOnReset = () => {
    if (JSON.stringify(params) !== JSON.stringify(initParams)) {
      setParams(initParams);
      setInitialization(true);
    }
  };

  /**
   * 스낵바 리덕스 값을 변경해주는 함수
   * @type {(...args: any[]) => any}
   */
  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  /**
   * modal 열어주는 함수
   */
  const handleModalOpen = (e) => {
    const { name } = e.currentTarget;
    if (name === 'add') {
      let newModal = {
        ...initModal,
        open: true,
        type: name,
        modalTitle: '패키지 등록',
        confirmBtnTitle: '등록',
      };
      setModal(newModal);
    }
  };

  /**
   * 모달 닫아주는 함수
   */
  const handleModalClose = () => {
    let newModal;
    newModal = {
      ...modal,
      open: false,
    };
    setModal(newModal);
  };

  /**
   * 모달에 submit 버튼을 눌렀을 때 실행되는 함수
   */
  const handleSubmit = () => {
    if (modal.type === 'add') {
      if (modal.params.pkgNm === '') {
        setError({
          ...initError,
          pkgNm: {
            state: true,
            helperText: t('패키지명은 필수입력 입니다.'),
          },
        });
        return;
      } else {
        setError(initError);
      }
      if (modal.params.appDesc === '') {
        setError({
          ...initError,
          appDesc: {
            state: true,
            helperText: t('설명은 필수입력 입니다.'),
          },
        });
        return;
      } else {
        setError(initError);
      }
      setLoading(true);
      appFilteringAdd(modal.params)
        .then((response) => {
          handleClickSnackbar({
            message: response.data.message,
            option: {
              type: 'success',
            },
          });
          setReGetData(true);
        })
        .catch((error) => {
          handleClickSnackbar({
            message: error,
            option: {
              type: 'error',
            },
          });
          setReGetData(false);
        })
        .finally(() => {
          setLoading(false);
        });
      handleModalClose();
    } else if (modal.type === 'delete') {
      appFilteringDel(checkData)
        .then((response) => {
          handleClickSnackbar({
            message: response.data.message,
            option: {
              type: 'success',
            },
          });
          setReGetData(true);
        })
        .catch((error) => {
          handleClickSnackbar({
            message: error,
            option: {
              type: 'error',
            },
          });
          setReGetData(false);
        })
        .finally(() => {
          setLoading(false);
        });
      handleModalClose();
    }
  };

  /**
   * 모달 데이터 변경했을 때 실행되는 함수
   * @param newParams
   */
  const modalGetParam = (newParams) => {
    setModal({
      ...modal,
      params: {
        ...newParams,
      },
    });
  };

  /**
   * 체크박스 Btn Callback 함수
   * @param type String (엑션타입)
   * @param rowData Array ( 체크 유니크값)
   */
  const handleHeadCallback = (type, dataList) => {
    if (type === 'delete') {
      let tmpAppNo = [];
      dataList.forEach(function (rowData) {
        tmpAppNo.push(rowData.APP_NO);
      });
      const dataParams = {
        appNos: tmpAppNo.join(),
      };
      setcCheckData(dataParams);
    }
    let newModal = {
      ...initModal,
      open: true,
      type: 'delete',
      modalTitle: '선택항목 삭제',
      confirmBtnTitle: '삭제',
    };
    setModal(newModal);
  };

  return (
    <>
      <NewFilterWrap handleOnReset={handleOnReset}>
        <NewCommonFilter
          initialization={initialization}
          getParam={getParam}
          params={params}
          useDisplayFilter={false}
          useExternalFilter={false}
          usePltfomTpCodeFilter={false}
          useDate={false}
        />
        <FilterCollection
          label={t('앱종류')}
          name="osTpCode"
          params={params}
          value={params.osTpCode}
          type="radio"
          list={[
            { label: '전체 ', value: 'all' },
            { label: 'Android', value: '01' },
            { label: 'iOS ', value: '02' },
          ]}
          callBack={getParam}
          labelKey="label"
          valueKey="value"
        />
        <NewButton type="modalBtn" name="add" onClick={handleModalOpen}>
          {t('등록')}
        </NewButton>
      </NewFilterWrap>
      <NewTableContainer
        params={params}
        getParam={getParam}
        dataReqPromise={appFiltering}
        useTotal={false}
        useCheckBox
        hasActController={{
          delete: true,
        }}
        headCallBack={handleHeadCallback}
        reFetch={reGetData}
        loading={loading}
        useExcel={false}
      />
      <Modal
        open={modal.open}
        headerOpen={modal.headerOpen}
        headerTitle={modal.modalTitle}
        handleClose={handleModalClose}
        confirmBtnTitle={modal.confirmBtnTitle}
        cancelBtnOpen={modal.cancelBtnOpen}
        cancelBtnTitle={modal.cancelBtnTitle}
        confirmOnClick={handleSubmit}
        useForm={modal.type === 'add'}
      >
        {modal.type === 'add' ? (
          <>
            <tr>
              <th>
                <b>* {t('OS 종류')}</b>
              </th>
              <td>
                <FilterCollection
                  label={t('앱종류')}
                  name="osTpCode"
                  params={modal.params}
                  value={modal.params.osTpCode}
                  type="radio"
                  list={[
                    { label: 'Android', value: '01' },
                    { label: 'iOS ', value: '02' },
                  ]}
                  callBack={modalGetParam}
                  labelKey="label"
                  valueKey="value"
                />
              </td>
            </tr>
            <tr>
              <th>
                <b>* {t('패키지입력')}</b>
              </th>
              <td>
                <NewInput
                  type="tableInput"
                  callBack={modalGetParam}
                  params={modal.params}
                  name="pkgNm"
                  value={modal.params.pkgNm}
                  placeholder={t('패키지명을 입력해주세요.')}
                  error={error.pkgNm.state}
                  helperText={error.pkgNm.helperText}
                />
              </td>
            </tr>
            <tr>
              <th>* {t('설명')}</th>
              <td>
                <NewInput
                  type="tableInput"
                  callBack={modalGetParam}
                  params={modal.params}
                  name="appDesc"
                  value={modal.params.appDesc}
                  error={error.appDesc.state}
                  helperText={error.appDesc.helperText}
                  placeholder={t('설명을 입력해주세요.')}
                  multiline
                  row={4}
                />
              </td>
            </tr>
          </>
        ) : (
          <p>{t('정말 삭제하시겠습니까?')}</p>
        )}
      </Modal>
    </>
  );
};

AppFiltering.propTypes = {
  //onRequestSort: PropTypes.func.isRequired,
};

export default AppFiltering;
